import { createClient, type SupabaseClient } from '@supabase/supabase-js'
import { isSupabaseConfigured, supabaseConfig } from '../data/supabaseConfig'

let client: SupabaseClient | null = null

/**
 * Returns a single shared Supabase client, or null when the project has not been
 * configured yet so callers can fall back to sample data instead of throwing.
 */
export function getSupabase(): SupabaseClient | null {
  if (!isSupabaseConfigured()) return null
  if (client) return client

  client = createClient(supabaseConfig.url, supabaseConfig.anonKey, {
    auth: { persistSession: false, autoRefreshToken: false }
  })
  return client
}
